import { keyframes } from '@chakra-ui/react';

import { ArrowDir } from '../utils';

export const ANIM_DURATION = 1.5;

export const revealFromLeft = keyframes`
  from { clip-path: inset(-25% 100% -25% -5%); }
  to   { clip-path: inset(-25% -5%  -25% -5%); }
`;

export const revealFromRight = keyframes`
  from { clip-path: inset(-25% -5% -25% 100%); }
  to   { clip-path: inset(-25% -5% -25% -5%);  }
`;

export const RADIUS = { base: '60px', md: '120px' };
export const EXTENSION_H = 24;
export const EXTENSION_OFFSET = 16;
export const BG = 'readOnlyGray';
export const MAIN_BODY_WIDTH: Record<ArrowDir, string> = { left: '92%', right: '88%' };
export const TAIL_WIDTH: Record<ArrowDir, string> = { left: '8%', right: '12%' };
export const ARROW_HEAD_WIDTHS = { base: '25px', md: '65px', lg: '77px' };
